<template>
	<Dropdown ref="dropdown">
		<DropdownItem
			:disabled="disabled || !customer.subscription"
			v-on:click="openSubscription()"
			icon="subscription">Go to subscription</DropdownItem>
		<DropdownSeparator />
    <DropdownItem
      :disabled="disabled"
      v-on:click="openBillwerk()"
      icon="creditcard"
    >Open in Billwerk</DropdownItem
    >
    <DropdownSeparator />
		<DropdownItem icon="klaviyo">
			Klaviyo profile
			<Dropdown>
				<DropdownItem
					:disabled="!hasKlaviyo"
					v-on:click="openInKlaviyo"
					icon="customer">Open in Klaviyo</DropdownItem>
				<DropdownSeparator />
				<DropdownItem
					:disabled="disabled || !hasKlaviyo"
					v-on:click="updateKlaviyo('master')"
					icon="master">Update from master</DropdownItem>
				<DropdownItem
					:disabled="disabled || !hasKlaviyo"
					v-on:click="updateKlaviyo('worker')"
					icon="worker">Update from worker</DropdownItem>
			</Dropdown>
		</DropdownItem>
		<DropdownSeparator />
		<DropdownItem :disabled="disabled" v-on:click="resetPassword()" icon="password">Send password reset</DropdownItem>
		<DropdownSeparator />
    <DropdownItem :disabled="disabled" v-on:click="updateInAuth0" icon="worker">Update in Auth0</DropdownItem>
    <DropdownSeparator />
    <DropdownItem
      :disabled="saving"
      v-on:click="loginAs()"
      icon="account">Log in as {{ customer.customer ? customer.customer.first_name : '...' }}</DropdownItem>
    <DropdownSeparator />
		<DropdownItem :disabled="disabled" v-on:click="openStripe()" icon="creditcard">Open in Stripe</DropdownItem>
		<template v-slot:content>
			<template v-if="loading">
				Loading ...
			</template>
			<template v-if="customer.customer">
				<h2>{{ customer.customer.full_name }}</h2>
				<div class="margin-top">
					<div>ID: {{ customer.customer.id }}</div>
					<div>
						<a :href="'mailto:' + customer.customer.email">{{ customer.customer.email }}</a>
					</div>
				</div>
			</template>
		</template>
	</Dropdown>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    invoked: false,
    loading: false,
    saving: false,
    customer: {
    }
  }),
  computed: {
    hasKlaviyo () {
      if (!this.customer.klaviyo) {
        return false
      }

      return !!this.customer.klaviyo.id
    },
    disabled () {
      if (this.saving || this.loading || !this.customer.customer) {
        return true
      }

      return !this.customer.customer.id
    }
  },
  methods: {
    toggle () {
      this.$refs.dropdown.toggle()

      this.load()
    },
    load (force) {
      if (!this.invoked || force) {
        this.invoked = true

        Vue.$api.get('/customer/' + this.id + '/quick-access', {}, {
          loader: toggle => this.loading = toggle,
          callback: data => this.parse(data)
        })
      }
    },
    updateKlaviyo (server) {
      Vue.api.post('/customer/' + this.id + '/update-klaviyo', {
        server_id: server
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => alert('Updated')
      })
    },
    loginAs () {
      Vue.api.post('/customer/' + this.id + '/login-as', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.onLoginAs(data)
      })
    },
    onLoginAs (data) {
      window.open(data.redirect_to)
    },
    parse (data) {
      this.customer = data
    },
    openStripe () {
      window.open('https://dashboard.stripe.com/customers/' + this.customer.stripe_id)
    },
    openSubscription () {
      this.$router.push('/subscription/' + this.customer.subscription.id)
    },
    resetPassword () {
      Vue.$api.post('/password-reset/request', {
        email: this.customer.customer.email
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => alert('Password reset instructions sent')
      })
    },
    updateInAuth0 () {
      Vue.$api.post('/user/' + this.customer.customer.id + '/auth0/update', {
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => alert('Profile updated in Auth0')
      })
    },
    openBillwerk () {
      window.open(
        'https://admin.billwerk.plus/#/rp/customers/customers/customer/' +
        this.customer.customer.id
      )
    },
    openInKlaviyo () {
      window.open(
        'https://www.klaviyo.com/profile/{id}/profile'
          .replace('{id}', this.customer.klaviyo.id)
      )
    }
  }
}
</script>
